// src/layouts/BaseLayout.tsx
import WaPage from "@awesome.me/webawesome-pro/dist/react/page/index.js";
import React from "react";
import { Link, Outlet } from "react-router-dom";

import { NavigationTracker } from "../analytics/NavigationTracker";
import Logo from "../assets/logo.svg";
import Canonical from "../components/Canonical";
import ScrollToTop from "../components/ScrollToTop";
import { useIsMobile } from "../hooks/useIsMobile";

const BaseLayout: React.FC = () => {
  const isMobile = useIsMobile(720);

  return (
    <div className="base-layout">
      <Canonical />

      <WaPage>
        <header
          slot="header"
          className="wa-split wa-width-full wa-py-m"
          style={{ background: "#60a5fa" }}
        >
          <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
            <div className="wa-cluster wa-gap-s" style={{ alignItems: "center" }}>
              <img src={Logo} alt="" aria-hidden style={{ width: 28, height: 28 }} />

              <h1
                className="wa-heading-l"
                style={{ color: "#e0e7ff", margin: 0, pointerEvents: "none" }}
              >
                BCP Taxi Fare Calculator
              </h1>
            </div>
          </Link>
        </header>

        <main className="main-layout">
          <ScrollToTop />
          <NavigationTracker />
          <Outlet />
        </main>

        <footer
          slot="footer"
          className="wa-stack wa-gap-xs wa-px-l wa-py-s wa-color-neutral-500"
          style={{
            borderTop: "1px solid rgba(15,23,42,0.08)",
            background: "rgba(15,23,42,0.03)",
          }}
        >
          {!isMobile && (
            <div className="wa-stack wa-gap-2xs wa-color-neutral-600">
              <span className="wa-caption-s">
                Estimates based on published BCP Council taxi tariffs.
              </span>
              <span className="wa-caption-s">Not affiliated with BCP Council.</span>
            </div>
          )}

          <div className="wa-cluster wa-gap-s" style={{ flexWrap: "wrap", alignItems: "center" }}>
            <a
              href={import.meta.env.VITE_GOOGLE_FEEDBACK_FORM_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="wa-caption-s"
              style={{ whiteSpace: "nowrap" }}
            >
              Share feedback
            </a>

            <Link to="/privacy" className="wa-caption-s" style={{ whiteSpace: "nowrap" }}>
              Privacy Policy
            </Link>

            <span className="wa-caption-s wa-color-neutral-600" style={{ whiteSpace: "nowrap" }}>
              © {new Date().getFullYear()} BCP Taxi Fare Calculator
            </span>
          </div>
        </footer>
      </WaPage>
    </div>
  );
};

export default BaseLayout;
